import TemplateView from '../../../TemplateView'
import ViewByDaysTaskRow from './ViewByDaysTaskRow'
import ConfigPanel from './ConfigPanel'
import DayRow from './dayRow/DayRow'
import CustomerRow from './CustomerRow'
import OvertimeRow from './OvertimeRow'
import ViewByDaysOtherSpentRow from './ViewByDaysOtherSpentRow'
import ViewByCPTaskRow from './ViewByCPTaskRow'
import ProjectRow from './ProjectRow'
import ViewByCPOtherSpentRow from './ViewByCPOtherSpentRow'
import LeaveRow from './LeaveRow'
import _ from 'underscore'
import LoadingMoire from '../../../LoadingMoire'
import $ from 'jquery'
import ViewTTStore from '../ViewTTStore'

export default class DetailsTable extends TemplateView {
    constructor() {
        super()

        this.state = {
            selectedTaskId: null
        }

        this.onStatePropertyChanged('selectedTaskId', selectedTaskId => this._updateSelectedTaskId(selectedTaskId))
    }

    templateHtml() {
        return "<div class='detailsTable'>" +
               "  <div class='title'><%=titleLabel%></div>" +
               "  <div class='configPanelContainer'></div>" +
               "  <div class='dayRowsContainer'>" +
               "    <table class='dayRows display-for-print' cellspacing='0' cellpadding='0'></table>" +
               "    <div class='noDayRowsLabel'><%=noDayRowsLabel%></div>" +
               "  </div>" +
               "  <div class='cpRowsContainer'>" +
               "    <table class='cpRows display-for-print' cellspacing='0' cellpadding='0'></table>" +
               "    <div class='noCPRowsLabel'><%-noCPRowsLabel%></div>" +
               "  </div>" +
               "</div>"
    }

    afterRender() {
        this.$configPanelContainer = this.find(".configPanelContainer");
        this.$dayRowsTable = this.find(".dayRows");
        this.$cpRowsTable = this.find(".cpRows");
        this.configPanel = new ConfigPanel().init(this.$configPanelContainer)
        this.loadingMoire = new LoadingMoire(ViewTTPageUtils.SPINNER_SETTINGS).init(this.$el)
        this._rememberDetailsTableConfig();

        $(document).on("viewTT.beginLoadData", () => this.disable())

        $(document).on("viewTT.endLoadData", () => this.enable())

        $(ViewTTStore).on("dataChange", () => this.update())

        $(ViewTTStore).on("detailsTableConfigChange", () => {
            this.update()
            $(document).trigger("viewTT.detailsTable.update")
            this._rememberDetailsTableConfig()
        })
    }

    update() {
        this._updateVisibilityClasses();

        this.$dayRowsTable.empty();
        this.$cpRowsTable.empty();

        const presentDataByDays = ViewTTPageUtils.tablePresentDataByDays();
        for (let row of presentDataByDays) {
            switch (row.type) {
                case ViewTTPageUtils.RowType.DAY:
                    new DayRow({dayModel: row.dayModel}).init(this.$dayRowsTable)
                    break
                case ViewTTPageUtils.RowType.LEAVE:
                    new LeaveRow(this.$dayRowsTable, row.dayModel, row.last).init()
                    break
                case ViewTTPageUtils.RowType.TASK_BY_DAY:
                    new ViewByDaysTaskRow({
                        dayModel: row.dayModel,
                        taskModel: row.taskModel,
                        last: row.last
                    }).init(this.$dayRowsTable)
                    break
                case ViewTTPageUtils.RowType.OTHER_SPENT_BY_DAY:
                    new ViewByDaysOtherSpentRow(this.$dayRowsTable, row.dayModel, row.last).init()
                    break
                case ViewTTPageUtils.RowType.OVERTIME:
                    new OvertimeRow(this.$dayRowsTable, row.dayModel, row.last).init()
                    break
            }
        }

        const presentDataByCP = ViewTTPageUtils.tablePresentDataByCP();
        for (let row of presentDataByCP) {
            switch (row.type) {
                case ViewTTPageUtils.RowType.CUSTOMER:
                    new CustomerRow({customerModel: row.customerModel}).init(this.$cpRowsTable)
                    break;
                case ViewTTPageUtils.RowType.OTHER_SPENT_BY_CP:
                    new ViewByCPOtherSpentRow(this.$cpRowsTable, row.otherTTInfo).init();
                    break;
                case ViewTTPageUtils.RowType.PROJECT:
                    new ProjectRow(this.$cpRowsTable, row.projectModel).init();
                    break;
                case ViewTTPageUtils.RowType.TASK_BY_CP:
                    const {taskModel, last} = row
                    new ViewByCPTaskRow({taskModel, last}).init(this.$cpRowsTable);
                    break;
            }
        }

        this.$el.toggleClass("hasDayRows", presentDataByDays.length > 0);
        this.$el.toggleClass("hasCPRows", presentDataByCP.length > 0);
        this.$el.toggleClass("otherUser", ViewTTStore.getSelectedUserId() !== ViewTTStore.getViewerId());

        this._updateSelectedTaskId(this.state.selectedTaskId)

        $(document).trigger("viewTT.detailsTable.update");
    }

    messageKeys() {
        return {
            titleLabel: "view_tt.details_table.title",
            noDayRowsLabel: "view_tt.details_table.no_day_rows",
            noCPRowsLabel: "view_tt.details_table.no_cp_rows"
        }
    }

    disable()
    {
        this.$el.attr("disabled", true);
        this.loadingMoire.show();
    }

    enable()
    {
        this.$el.attr("disabled", false);
        this.loadingMoire.hide();
    }

    _updateVisibilityClasses()
    {
        const detailsTableConfig = ViewTTStore.getDetailsTableConfig();
        this.$el.toggleClass("viewByDays", detailsTableConfig.viewByDays);
        this.$el.toggleClass("viewByCP", !detailsTableConfig.viewByDays);
        this.$el.toggleClass("showTasks", detailsTableConfig.showTasks);
        this.$el.toggleClass("hideTasks", !detailsTableConfig.showTasks);
    }

    _rememberDetailsTableConfig()
    {
        this.prevDetailsTableConfig = _.clone(ViewTTStore.getDetailsTableConfig());
    }

    _updateSelectedTaskId(taskId) {
        this.find(".taskRow.editing").removeClass("editing")
        if (taskId) {
            this.find(".task" + taskId).addClass("editing")
        }
    }
}



// WEBPACK FOOTER //
// ./web/js/user/viewtt/detailsTable/DetailsTable.js